// The ReauthSheet (D74): the person's password before a sensitive action goes on, in the kit's ReauthSheet. A wrong
// password answers inline; success retries the waiting call (`withReauth`). It cannot be dismissed by the scrim while
// the action waits. From 600 px it is the centred dialog, below the bottom sheet.
import { ids } from '@orca/api-client/testIds'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReauthSheet as Sheet } from '../../components/ui/reauth-sheet'
import { api } from '../../shared/api/api'
import { useWindowClass } from '../../shared/shell/useWindowClass'
import { formProblem } from '../auth/formProblem'
import { reauth, useReauthOpen } from './reauth'
import './strings'

export function ReauthSheet() {
  const { t } = useTranslation()
  const open = useReauthOpen()
  const dialog = useWindowClass() !== 'compact'
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [message, setMessage] = useState<string>()

  async function confirm() {
    setBusy(true)
    setMessage(undefined)
    try {
      await api.POST('/auth/reauthenticate', { body: { password } })
      setPassword('')
      reauth.confirmed()
    } catch (error) {
      setMessage(formProblem(error, []).message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <Sheet
      open={open}
      dialog={dialog}
      title={t('reauth.title')}
      message={t('reauth.body')}
      passwordLabel={t('reauth.password')}
      value={password}
      onValue={setPassword}
      error={message}
      checking={busy}
      confirmLabel={t('reauth.confirm')}
      cancelLabel={t('reauth.cancel')}
      onConfirm={() => void confirm()}
      onCancel={reauth.cancelled}
      testId={ids.reauthSheet.root}
      fieldTestId={ids.reauthSheet.passwordField}
      confirmTestId={ids.reauthSheet.confirmButton}
      cancelTestId={ids.reauthSheet.cancelButton}
    />
  )
}
